import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/home/customer2.png'


const _hoisted_1 = { class: "contact-us" }

import store from '@/store';
import { ref, watch, onMounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactUs2',
  setup(__props) {

const topObj: any = ref(null);

onMounted(() => {
  let contactUsTop: any = store.state.contactUsTop;
  if (contactUsTop) {
    topObj.value = { ...contactUsTop };
  }
})

watch(store.state.contactUsTop, (newState) => {
  if (newState) {
    topObj.value = { ...newState };
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "contact-us-wrap",
    style: _normalizeStyle(topObj.value)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "closed",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).state.contactUsTop = null))
      }),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, "联系我们的团队", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("div", null, "您可以通过以下几种方式联系我们，我们将为您提供专业的解答", -1)),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "content" }, [
        _createElementVNode("div", null, [
          _createElementVNode("img", { src: _imports_0 }),
          _createElementVNode("div", null, "扫码添加客服微信")
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", null, "咨询电话"),
          _createElementVNode("div", null, "400-900-6269"),
          _createElementVNode("div", { class: "working-hours" }, "工作日：09:00-18:00（北京时间）")
        ])
      ], -1))
    ])
  ], 4))
}
}

})